var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturnIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1775 12.6358H30V16.3642H7.1775L17.235 26.364L14.5837 29L0 14.5L14.5837 0L17.235 2.63602L7.1775 12.6358Z",
    fill: "#EEA111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnIcon);
export default __webpack_public_path__ + "static/media/return_icon.ddb7f2babaabcaa43fa459c5f54a1c31.svg";
export { ForwardRef as ReactComponent };